import {Seo} from 'src/components/seo';
import {usePageView} from 'src/hooks/use-page-view';
import {Box} from '@mui/material'
import {Logo} from "src/components/logo";
import {UseListOptions} from "../hooks/masterdata/use-list-options";

const Page = () => {
    UseListOptions()

    return (
        <>
            <Seo/>

            <Box
                sx={{
                    alignItems: 'center',
                    backgroundPosition: 'top center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    flex: {
                        xs: '0 0 auto',
                        sm: '10 1 auto',
                        md: '1 1 auto'
                    },
                    justifyContent: 'center',
                    p: {
                        xs: 4,
                        md: 8
                    }
                }}
            >
                <Box maxWidth="lg">
                    <Logo height={150}/>
                </Box>
            </Box>
        </>
    );
};

export default Page;
